export default __webpack_public_path__ + "static/media/korean-japchae.9e008a90.png";